var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"outlined":"","type":"info"}},[_vm._v(" "+_vm._s(_vm.pendingText)+" "),_c('a',{attrs:{"href":_vm.firstWaitlistedDate}},[_vm._v("Go to date with next pending waitlist.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }